import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  column: {
    minWidth: 300,
    width: 300,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    overflow: 'clip',
    isolation: 'isolate',
    boxShadow: '0px 2px 10px rgba(0,0,0,0.18)',
    borderLeft: `1.5px solid ${theme.palette.grey[400]}`,
    borderRight: `1.5px solid ${theme.palette.grey[400]}`,
    borderBottom: `1.5px solid ${theme.palette.grey[400]}`,
  },
  columnHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    willChange: 'transform',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 2, 1.5),
    borderTop: `1.5px solid ${theme.palette.grey[400]}`,
    borderBottom: `1.5px solid ${theme.palette.grey[400]}`,
  },
  columnBody: {
    padding: theme.spacing(2),
  },
  columnHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  colorIndicator: {
    width: 4,
    height: 20,
    borderRadius: 2,
    flexShrink: 0,
  },
  columnTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.text.primary,
  },
  columnCount: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  columnActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  actionButton: {
    padding: 4,
    color: theme.palette.text.secondary,
  },
  droppable: {
    minHeight: 118,
  },
  droppableScroll: {
    height: '100%',
  },
  droppableDraggingOver: {
    backgroundColor: theme.palette.grey[100],
    borderRadius: 6,
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3, 1),
    color: theme.palette.text.secondary,
    gap: 4,
  },
  emptyIcon: {
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(0.5),
  },
  emptyTitle: {
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  emptySubtitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
  sentinel: {
    height: 1,
  },
  skeleton: {
    borderRadius: 6,
    marginBottom: theme.spacing(1),
  },
  createButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    width: '100%',
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    border: `1.5px dashed ${theme.palette.grey[400]}`,
    borderRadius: 6,
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    fontSize: 13,
    backgroundColor: 'transparent',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[50],
    },
  },
}))

export default useStyles
